<template>
    <div>
        <v-panel v-if="isRender" :class="theme.breadCrumbs">
            <div v-padding.left="2" v-padding.right="2">
                <v-icon-button @click="handleClick">
                    arrow_back
                </v-icon-button>
                <v-text type="title" middle>
                    {{ title }}
                </v-text>
            </div>
        </v-panel>
    </div>
</template>
<script>
import theme from './theme.scss';

export default {
    name: 'bread-crumbs',
    props: {
        theme: {
            type: Object,
            default() {
                return theme;
            }
        }
    },
    computed: {
        isRender() {
            return this.$route.path !== '/';
        },
        prevPath() {
            return this.$route.meta.breadCrumbs === undefined
                ? '/'
                : this.$route.meta.breadCrumbs;
        },
        title() {
            return this.$route.meta.title || 'Вернуться';
        }
    },
    methods: {
        handleClick() {
            if (typeof this.prevPath === 'number') {
                this.$router.go(this.prevPath);
            } else {
                this.$router.push(this.prevPath);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// BreadCrumbs.vue?687cf6ed